import { aeoRecommendationIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod";

export const restoreAeoRecommendation = {
  name: "restoreAeoRecommendation" as const,
  input: z.object({ recommendationId: aeoRecommendationIdFormat.schema }),
  output: z.object({}),
};
